const actions = {
  async nuxtServerInit({ dispatch }) {
    await dispatch('category/getList');
  },
};

// eslint-disable-next-line import/prefer-default-export
export { actions };
